import LoginImage from './LoginImage';

export default LoginImage;
